<template>
  <div class="ItemInfoList">
    <div class="bg_black text_white">
      <div class="ninew bodybox">
        <van-nav-bar
          left-arrow
          fixed
          @click-left="goback"
          :title="$t('platform.itemInfo')"
        >
          <van-icon
            v-if="type == 'edit'"
            name="./static/img/Trash.png"
            slot="right"
            @click="delgoods()"
            style="font-size: 24px"
          />
        </van-nav-bar>
      </div>
    </div>

    <!-- 表單模塊 -->
    <div class="shopList ninew bodybox">
      <!-- 物品名稱 -->
      <van-cell-group>
        <van-field
          v-model="itemInfo.name"
          :label="$t('itemInfo.name')"
          clearable
          :placeholder="$t('itemInfo.inputName')"
        />
      </van-cell-group>
      <!-- <van-cell-group>
        <van-field
          v-model="itemInfo.number"
          :label="$t('itemInfo.number')"
          clearable
          :placeholder="$t('itemInfo.inputNumber')"
        />
      </van-cell-group> -->
      <!-- 物品單位 -->
      <van-cell-group v-if="unitArr.length > 0">
        <van-cell
          :title="$t('itemInfo.company')"
          :value="itemInfo.company"
          is-link
          @click="showLanguage = true"
        />
        <van-popup
          v-model="showLanguage"
          position="bottom"
          v-if="showLanguage"
        >
          <van-picker
            show-toolbar
            :columns="unitArr"
            value-key="name"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="showLanguage = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </van-cell-group>
      <van-cell-group v-else>
        <van-field
          :label="$t('itemInfo.company')"
          readonly
          :value="$t('itemInfo.nodatamsg')"
        />
      </van-cell-group>
      <!-- 條形碼 -->
      <van-cell-group>
        <van-field
          v-model="itemInfo.code"
          :label="$t('itemInfo.barCode')"
          clearable center
          :placeholder="$t('itemInfo.barCode')"
          use-button-slot
        >
        </van-field>
      </van-cell-group>
      <!-- save button -->
      <van-button class="testBtn" round @click="submit">{{
        $t("PackageDish.save")
      }}</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      itemInfo: {
        name: "",
        number: "",
        company: "",
        code: "",
      },
      showLanguage: false,
      unitArr: [],
      company_id: "1",
      type: "add",
      goodsId: "",
    };
  },
  mounted() {
    this.getAllUnits();
    if (this.$route.query.id) {
      this.type = "edit";
      this.goodsId = this.$route.query.id;
      // 获取当前物品资料
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + `/api/goods/${this.goodsId}/show`,
      })
        .then((res) => {
          if (res.data.status == 200) {
            console.log(res.data.data);
            this.itemInfo.name = res.data.data.name;
            this.itemInfo.code=res.data.data.code
            this.itemInfo.company = res.data.data.unit.name;
            this.company_id=res.data.data.unit.id
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {});
    }
  },
  methods: {
    goback() {
      this.$router.go(-1); //返回上一层
    },
    //多语言选择
    onConfirm(e) {
      this.itemInfo.company = e.name;
      this.showLanguage = false;
      this.company_id = e.id;
    },
    getAllUnits() {
      // 获取所有单位
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + "/api/unit/index",
      })
        .then((res) => {
          if (res.data.status == 200) {
            console.log(res.data.data);
            this.unitArr = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {});
    },
    delgoods() {
      this.$dialog
        .confirm({
          title: this.$t("itemInfo.deleteP"),
          message: this.$t("itemInfo.isDeleteP"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel"),
        })
        .then(() => {
          this.$axios({
            method: "delete",
            headers: {
              Authorization: "Bearer " + sessionStorage.token,
            },
            url: this.$build + `/api/goods/${this.goodsId}/destroy`,
            data: null,
          })
            .then((res) => {
              console.log(res.data);
              if (res.data.status == 200) {
                this.$toast({
                  type: "success",
                  message: this.$t("itemInfo.successDelMsg"),
                });
                const vm = this;
                setTimeout(function () {
                  vm.$router.go(-1);
                }, 1500);
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item],
                  });
                }
              }
            })
            .catch((err) => {
              this.$toast({
                type: "fail",
                message: this.$t("ShopList.message"),
              });
            });
        });
    },
    submit() {
      if (this.type == "edit") {
        var data = {
          unit_id: this.company_id,
          name: this.itemInfo.name,
          code:this.itemInfo.code
        };
        console.log(data)
 
        this.$axios({
          method: "patch",
          headers: {
            Authorization: "Bearer " + sessionStorage.token,
          },
          url: this.$build + `/api/goods/${this.goodsId}/update`,
          data: data,
        })
          .then((res) => {
            console.log(res.data);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: this.$t("itemInfo.editSuccessMsg"),
              });
              const vm = this;
              setTimeout(function () {
                vm.$router.go(-1);
              }, 1500);
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item],
                });
              }
            }
          })
          .catch((err) => {
            this.$toast({
              type: "fail",
              message: this.$t("ShopList.message"),
            });
          });
      } else {
        // 新增物品信息
        var data = {
          store_id: sessionStorage.getItem("actShopId"),
          unit_id: this.company_id,
          name: this.itemInfo.name,
        };
        console.log(data)
        
        this.$axios({
          method: "post",
          headers: {
            Authorization: "Bearer " + sessionStorage.token,
          },
          url: this.$build + "/api/goods/store",
          data: data,
        })
          .then((res) => {
            console.log(res.data);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: this.$t("itemInfo.successMsg"),
              });
              const vm = this;
              setTimeout(function () {
                vm.$router.go(-1);
              }, 1500);
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item],
                });
              }
            }
          })
          .catch((err) => {
            this.$toast({
              type: "fail",
              message: this.$t("ShopList.message"),
            });
          });
      }
    },
  },
};
</script>

<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-cell-group--inset {
  margin: 0;
  margin-top: 15px;
}
/deep/ .van-cell {
  color: #646566;
}

.shopList {
  /* padding-top: 20px; */
}
.testBtn {
  width: 50%;
  margin: 15px 25%;
  background: #2f75f4;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/Platform/ItemInfoAdd.vue